import qs from "qs";
import { ApiClientBase } from "api/ApiClientBase";

class SchoolSummaryApiClient extends ApiClientBase {
    buildSchoolSummary(schoolId, format) {
        return this.post(
            `api/v1/school/summary/${schoolId}/build?${qs.stringify({ format })}`,
        ).then((x) => x.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SchoolSummaryApiClient();
